// extracted by mini-css-extract-plugin
export default {"pickerContainer":"color-picker_pickerContainer__kxtrG","translated":"color-picker_translated__cO5Xj"};